@use "ui/styles/breakpoints";
@use "ui/styles/colorsOld";
@use "ui/oldStyles/utils";
@use "ui/styles/fontsOld";
@use "ui/oldStyles/variables/spacing";
@use "ui/oldStyles/symbols";

.wrapper {
  :global {
    .modal-subheader {
      font-size: 12px;
      color: colorsOld.$stoneDarkX1;
      margin: 12px 12px 0;
      padding: 9px 12px;
      border-radius: 4px;
      background-color: colorsOld.$stoneLightX5;
    }

    .modal-subheader-message-wrapper {
      margin: 0 auto;
      min-height: 35px;
    }

    .modal-body {
      padding: 30px 24px 30px;
      background-color: white;

      .banner {
        align-items: center;
        border-radius: 4px;
        display: flex;
        margin-bottom: 30px;
        padding: 9px;

        &.warning {
          background-color: colorsOld.$gold;
          color: colorsOld.$goldDark;
        }

        svg {
          margin-right: 9px;
        }

        p {
          color: colorsOld.$white;
          font-size: fontsOld.$small;
        }

        a {
          color: colorsOld.$white;
        }
      }

      .modal-input-unit {
        color: colorsOld.$stone;
        padding-left: 12px;
      }

      input,
      textarea {
        &.empty {
          border-color: rgba(0, 0, 0, 0);
        }

        &.error {
          border-color: colorsOld.$ruby;
        }

        &.valid {
          border-color: colorsOld.$sapphire;
        }
      }
    }

    .modal-footer {
      padding: 24px;
      border-top: 1px solid colorsOld.$stoneLightX1;
      background-color: white;
      display: flex;
      justify-content: space-between;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;

      .footer-left-top {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        color: colorsOld.$stoneDark;
        margin-bottom: 4px;

        .line-through-value {
          color: colorsOld.$stoneLight;
          text-decoration: line-through;
          margin-left: 0.5em;
        }

        .changed-badge {
          padding: 6px 8px;
          margin-right: 12px;
          border-radius: 6px;
          border: 1px solid colorsOld.$stoneLight;
          color: colorsOld.$stone;
          font-size: 12px;
        }
      }

      .footer-left-bottom {
        font-size: 14px;
        color: colorsOld.$stone;

        &.error {
          color: colorsOld.$ruby;
        }
      }

      .footer-left {
        .step-counter {
          border-radius: 4px;
          background-color: colorsOld.$stoneLightX5;
          color: colorsOld.$stoneDark;
          display: flex;
          font-size: 14px;
          padding: 12px 16px;
        }
      }

      .footer-right {
        display: flex;
        align-items: center;

        button {
          margin-left: 12px;
        }

        @include breakpoints.mobile {
          .modal-cancel-btn {
            display: none;
          }
        }
      }
    }
  }
}